import { render, staticRenderFns } from "./Proposta.vue?vue&type=template&id=33ddfc8c&scoped=true"
import script from "./Proposta.vue?vue&type=script&lang=js"
export * from "./Proposta.vue?vue&type=script&lang=js"
import style0 from "./Proposta.vue?vue&type=style&index=0&id=33ddfc8c&prod&lang=stylus"
import style1 from "./Proposta.vue?vue&type=style&index=1&id=33ddfc8c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ddfc8c",
  null
  
)

export default component.exports